import { render } from "./ConsolationView.vue?vue&type=template&id=6782819f"
import script from "./ConsolationView.vue?vue&type=script&lang=js"
export * from "./ConsolationView.vue?vue&type=script&lang=js"

import "./ConsolationView.vue?vue&type=style&index=0&id=6782819f&lang=css"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__